// extracted by mini-css-extract-plugin
export var container = "_9j-0";
export var error = "_9j-9";
export var label = "_9j-5";
export var light = "_9j-6";
export var md = "_9j-3";
export var sm = "_9j-2";
export var thin = "_9j-8";
export var thinBold = "_9j-7";
export var vertical = "_9j-4";
export var xs = "_9j-1";